window.scrollBar = 0; // ScrollBar genişlik değeri
window.device = false; // Mobil Cihaz durumu
window.globalWidth = 0; // Ekran Genişlik değeri
window.listurl = decodeURI(document.location.href.replace(document.location.origin, ''));
window.getinside = '';
var offset = 200;

$(document).ready(function () {
    if ($('#rnd-mobile-menu .mobile-dg-line').length > 0) {
        $('#rnd-mobile-menu .static-menu').css('padding-bottom', '70px');
    }
    $('.checkmark').click(function (e) {
        e.preventDefault();
        if (!$(this).parent().find('input').prop('checked')) {
            $(this).parent().find('.fancybox').click();
        }
        else {
            $(this).parent().find('input').prop('checked', false);
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('[data-search-result]').length && !$(e.target).closest('.icon-search').length && !$(e.target).closest('#searchHomeMobil').length) {
            $('[data-search-result]').hide();
            $('[data-input-search]').val('');
            $('#searchHomeMobile').hide();
        }
    });
});

window.layoutModule = {
    init: function () {
        layoutModule.events();
        layoutModule.getFavoriteCount();
    },
    checkCookie: function () {
        var _cookies = {};
        $.each(document.cookie.split(';'), function (i, e) {
            var _cookie = e.split('=');
            _cookies[_cookie[0].trim()] = _cookie[1];
        });
        if (_cookies.genderCookie == 'undefined' || _cookies.genderCookie == undefined) {
            $('#men').hide();
            $('#home').hide();
            $('#women').fadeIn();
            $('#turkishDesigner').hide();
            $('#cocuk').hide();

            $('#menuListMen').hide();
            $('#menuListHome').hide();
            $('#menuListTurkishDesigner').hide();
            $('#menuListWomen').show();
            $('#menuListCocuk').hide();
            layoutModule.flexSliderInit();

            $('#pMenMobileMenu').hide();
            $('#pHomeMobileMenu').hide();
            $('#pturkishDesignerMobileMenu').hide();
            $('#pWomenMobileMenu').show();
            $('#pCocukMobileMenu').hide();

            $('a[data-href="men"]').removeClass("active");
            $('a[data-href="home"]').removeClass("active");
            $('a[data-href="turkishDesigners"]').removeClass("active");
            $('a[data-href="women"]').addClass("active");
            $('a[data-href="cocuk"]').removeClass("active");

            $('#shopMen').parents(".accordion-item").addClass("active");
            $.cookie('genderCookie', "women");
        }
        else {
            //if (CurrentPathName != "/") {
            if ($.cookie("genderCookie") == "women") {
                $('#men').hide();
                $('#home').hide();
                $('#women').fadeIn();
                $('#turkishDesigner').hide();
                $('#cocuk').hide();

                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListWomen').show();
                $('#menuListCocuk').hide();
                layoutModule.flexSliderInit();

                $('#pMenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pturkishDesignerMobileMenu').hide();
                $('#pWomenMobileMenu').show();
                $('#pCocukMobileMenu').hide();

                $('a[data-href="men"]').removeClass("active");
                $('a[data-href="home"]').removeClass("active");
                $('a[data-href="turkishDesigners"]').removeClass("active");
                $('a[data-href="cocuk"]').removeClass("active");
                $('a[data-href="women"]').addClass("active");

                $('#shopMen').parents(".accordion-item").addClass("active");
                $.cookie('genderCookie', "women");
            } else if ($.cookie("genderCookie") == "men") {
                $('#women').hide();
                $('#home').hide();
                $('#men').fadeIn();
                $('#turkishDesigner').hide();
                $('#cocuk').hide();

                $('#pWomenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pturkishDesignerMobileMenu').hide();
                $('#pMenMobileMenu').show();
                $('#pCocukMobileMenu').hide();

                $('#menuListWomen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListMen').show();
                $('#menuListCocuk').hide();
                layoutModule.flexSliderInit();

                $('a[data-href="women"]').removeClass("active");
                $('a[data-href="home"]').removeClass("active");
                $('a[data-href="turkishDesigners"]').removeClass("active");
                $('a[data-href="cocuk"]').removeClass("active");
                $('a[data-href="men"]').addClass("active");

                $('#shopWomen').parents(".accordion-item").addClass("active");
                $('#shopHome').parents(".accordion-item").addClass("active");
                $.cookie('genderCookie', "men");
            } else if ($.cookie("genderCookie") == "home") {
                $('#women').hide();
                $('#men').hide();
                $('#home').fadeIn();
                $('#turkishDesigner').hide();

                $('#cocuk').hide();
                $('#pWomenMobileMenu').hide();
                $('#pMenMobileMenu').hide();
                $('#pturkishDesignerMobileMenu').hide();
                $('#pHomeMobileMenu').show();
                $('#pCocukMobileMenu').hide();

                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListHome').show();
                $('#menuListCocuk').hide();
                layoutModule.flexSliderInit();

                $('a[data-href="women"]').removeClass("active");
                $('a[data-href="men"]').removeClass("active");
                $('a[data-href="turkishDesigners"]').removeClass("active");
                $('a[data-href="cocuk"]').removeClass("active");
                $('a[data-href="home"]').addClass("active");
                $('#shopWomen').parents(".accordion-item").addClass("active");
                $('#shopMen').parents(".accordion-item").addClass("active");
                $.cookie('genderCookie', "home");
            }
            else if ($.cookie("genderCookie") == "turkishDesigners") {
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#cocuk').hide();
                $('#turkishDesigner').fadeIn();

                $('#pWomenMobileMenu').hide();
                $('#pMenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pturkishDesignerMobileMenu').show();
                $('#pCocukMobileMenu').hide();

                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').show();
                $('#menuListCocuk').hide();
                layoutModule.flexSliderInit();

                $('a[data-href="women"]').removeClass("active");
                $('a[data-href="men"]').removeClass("active");
                $('a[data-href="home"]').removeClass("active");
                $('a[data-href="turkishDesigners"]').addClass("active");
                $('a[data-href="cocuk"]').removeClass("active");
                $('#shopWomen').parents(".accordion-item").addClass("active");
                $('#shopMen').parents(".accordion-item").addClass("active");
                $('#shopHome').parents(".accordion-item").addClass("active");
                $.cookie('genderCookie', "turkishDesigners");
            }

            else if ($.cookie("genderCookie") == "pet") {
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#cocuk').hide();
                $('#turkishDesigner').hide();
                $('#pet').fadeIn();

                $('#pWomenMobileMenu').hide();
                $('#pMenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pturkishDesignerMobileMenu').hide();
                $('#pPetMobileMenu').show();
                $('#menuListCocuk').hide();
                $('#pCocukMobileMenu').hide();

                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').show();
                layoutModule.flexSliderInit();

                $('a[data-href="women"]').removeClass("active");
                $('a[data-href="men"]').removeClass("active");
                $('a[data-href="home"]').removeClass("active");
                $('a[data-href="cocuk"]').removeClass("active");
                $('a[data-href="turkishDesigners"]').removeClass("active");
                $('a[data-href="pet"]').addClass("active");
                $('#shopWomen').parents(".accordion-item").addClass("active");
                $('#shopMen').parents(".accordion-item").addClass("active");
                $('#shopHome').parents(".accordion-item").addClass("active");
                $.cookie('genderCookie', "pet");
                setTimeout(function () {
                    $('[data-js=wplaceholder]').addClass('js-loaded');
                }, 5000)
            }
            else if ($.cookie("genderCookie") == "cocuk") {
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#cocuk').fadeIn();

                $('#pWomenMobileMenu').hide();
                $('#pMenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pturkishDesignerMobileMenu').hide();
                $('#pPetMobileMenu').hide();
                $('#pCocukMobileMenu').show();

                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListCocuk').show();
                layoutModule.flexSliderInit();

                $('a[data-href="women"]').removeClass("active");
                $('a[data-href="men"]').removeClass("active");
                $('a[data-href="home"]').removeClass("active");
                $('a[data-href="turkishDesigners"]').removeClass("active");
                $('a[data-href="pet"]').removeClass("active");
                $('a[data-href="cocuk"]').addClass("active");
                $('#shopWomen').parents(".accordion-item").addClass("active");
                $('#shopMen').parents(".accordion-item").addClass("active");
                $('#shopHome').parents(".accordion-item").addClass("active");
                $.cookie('genderCookie', "cocuk");
                setTimeout(function () {
                    $('[data-js=wplaceholder]').addClass('js-loaded');
                }, 5000)
            }
        }
    },
    events: function () {
        var $inputSearch = $('[data-input-search]');
        var regex = /[a-zA-Z\-0-9\@.-_]/;
        $('.ebulten-text').keydown(function (e) {
            return regex.test(e.key);
        });

        $inputSearch.keyup(function () {

            if (this.value.match(/[^0-9^a-z[şŞıİçÇöÖüÜĞğ ]/gi)) {

                this.value = this.value.replace(/[^0-9^a-z[şŞıİçÇöÖüÜĞğ ]/gi, '');

            }
        });



        $(window).resize(function () {
            if (globalWidth != $(window).width()) {
                layoutModule.mobileResize();
                layoutModule.GetSmallBasket(false);
            }
            layoutModule.toCallMobilePhone();
        });
        $(window).scroll(function () {
            layoutModule.sticky();
            //widgetScroll();
            //departmentSticky();
            //layoutModule.searchClose();
        });

        $(window).load(function () {

            setTimeout(function () {
                if ($.cookie("MyFavoriteProducts") != undefined) {
                    var favorites = $.cookie("MyFavoriteProducts").split(',');
                    for (var i = 0; i < favorites.length; i++) {
                        $('.pitem').each(function () {

                            if ($(this).find('input[name="pid"]').val() == favorites[i]) {
                                $(this).find('.add-favorite').addClass('activefavorite');
                            }
                        });
                        $('#productgallery .add-favorite input').each(function () {
                            if ($(this).val() == favorites[i]) {
                                $(this).prev().addClass('activefavorite');
                            }
                        });
                    }
                }

            }, 500);

            /*** Black Friday ***/
            //if (window.location.pathname == "/Icerik/GetContent/3395" && homePageTemplate == "blackfriday") {
            //    $('#container').css("background", "#000");
            //    $('.bank-banner-area').css('color', '#fff');
            //    $('.bank-banner-area li').css('border', '1px solid #fff');
            //    $('.bank-banner-list').css('color', '#fff');
            //    $('.bank-banner-list li').css('border', '1px solid #fff');
            //    $('.bank-campaign-title').css('color', '#fff');
            //    $('.bank-campaign-title').css('background', '#232222');
            //}
            ///*** Black Friday * END ***/
            layoutModule.mobileResize();

            globalWidth = $(window).width();
            /* - - Sayfa yüklenmesi tamamlandıktan sonra loading'i gizler - - */
            $('.mobile-loading').css('display', 'none');
            /* - - Sayfa yüklenmesi tamamlandıktan sonra loading'i gizler - End - */
            $('body').addClass('load');
        });
        $(window).resize(function () {
            if (globalWidth != $(window).width()) {
                globalWidth = $(window).width();
            }
        });
        $(document).click(function (e) {
            var target = e.target;
            if (!$(target).is('.townList') && !$(target).is('#searcTownBtn') && !$(target).is('#searchTown')) {
                $('.townList').fadeOut();
                if (!$(target).is('#MobileNav') && !$(target).is('.searchinput') && !$(target).is('.search-button') && !$(target).is('#leftnav') && $('#leftnav').hasClass('open')) {
                    layoutModule.navbarClosed();
                }
            }

        });
        $("#sbmtOrderTrack").on("click", function () {
            if ($("#txtEmail").val() == "" || $("#txtOrderNumber").val() == "") {
                var areas = $("#tracker-information :input");
                areas.each(function () {
                    $(this).attr("placeholder", "Doldurulması zorunlu alandır.");
                })
                return false;
            };
        });
        $('body').on('submit', '#signInFormheader', function (e) {
            var namee = $('#Register_Nameheader').validateControl();
            var surnamee = $('#Register_Surnameheader').validateControl();
            var emaill = $('#Register_Emailheader').validateControl();
            var passwordd = $('#Register_Passwordheader').validateControl();
            var gsm = $('#Register_Tel').validateControl();
            var contractResultheader = layoutModule.signInCheckboxheaderControl();
            return namee && surnamee && emaill && passwordd && contractResultheader /*  gsm   && gender && workingStatus &&  day && month && year*/
        });
        layoutModule.getReqID();
        layoutModule.mobileResize();
        var IsActive = isActive;
        var timerCookie = layoutModule.getCookie('timer_ok');
        //GetPTView("PWomen", "#women");
        //GetPTView("PMen", "#men");
        if (device) {
            layoutModule.GetPTView("_PMobileNav", "#pmobilenav");
        }
        var CurrentPathName = window.location.pathname;

        layoutModule.checkCookie();
        $(window).on('load', function () {
            layoutModule.checkCookie();
        });
        //}
        //else {
        //    $('#men').hide();
        //    $('#home').hide();
        //    $('#women').fadeIn();
        //    $('#pMenMobileMenu').hide();
        //    $('#pHomeMobileMenu').hide();
        //    $('#pWomenMobileMenu').show();

        //    $('#menuListMen').hide();
        //    $('#menuListHome').hide();
        //    $('#menuListWomen').show();
        //    layoutModule.flexSliderInit();

        //    $('a[data-href="men"]').removeClass("active");
        //    $('a[data-href="home"]').removeClass("active");
        //    $('a[data-href="women"]').addClass("active");
        //    $('#shopMen').parents(".accordion-item").addClass("active");
        //    $.cookie('genderCookie', "women");

        //}
        layoutModule.mobileResize();
        if (device) {
            $('.header-top .small-basket').remove();
            $('.header-mobile .header-right').append('<div class="small-basket"></div>');
        }
        layoutModule.GetSmallBasket(false);
        layoutModule.GetUserMenu('PUserMenu', '.user-menu')
        if (device) {
            setTimeout(function () {
                layoutModule.GetUserMenu('PMobileUserMenu', '#navusermenu');
            }, 1000);
            $('.icon-search').click(function () {
                $('#searchHomeMobile').show();
            });
        }
        $('.fancybox').fancybox();

        if (timerCookie != 'ok' && IsActive != 0 && $(window).width() > 768) {
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
            window.getpopup = $('#popupwrapinside div:first').html();
            layoutModule.fillinside(window.getpopup);
            layoutModule.setCookie('timer_ok', 'ok', 1);
        }

        $('body').on('click', '.accordion-header a.mainnav', function () {
            $('.accordion-item').removeClass("active");
            $(this).parents('.accordion-item').addClass("active");
            if ($(this).attr("id") == "shopWomen") {
                //$('#men').html('');
                //GetPTView("PWomen", "#women");
                $('#men').hide();
                $('#home').hide();
                $('#women').fadeIn();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();
                $('#pCocukMobileMenu').hide();

                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListWomen').show();

                $('#pMenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pWomenMobileMenu').show();
                $.cookie('genderCookie', "women");
                setTimeout(function () {
                    $("#shopMen").parents('.accordion-item').addClass("active");
                    $("#shopHome").parents('.accordion-item').addClass("active");
                }, 500);

            } else if ($(this).attr("id") == "shopMen") {
                //$('#women').html('');
                //GetPTView("PMen", "#men");
                $('#women').hide();
                $('#home').hide();
                $('#men').fadeIn();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();
                $('#pCocukMobileMenu').hide();

                $('#menuListWomen').hide();
                $('#menuListHome').hide();
                $('#menuListMen').show();


                $('#pWomenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pMenMobileMenu').show();
                $.cookie('genderCookie', "men");
                setTimeout(function () {
                    $("#shopWomen").parents('.accordion-item').addClass("active");
                    $("#shopHome").parents('.accordion-item').addClass("active");
                }, 500);
            } else if ($(this).attr("id") == "shopHome") {
                //$('#women').html('');
                //GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').fadeIn();

                $('#cocuk').hide();
                $('#menuListCocuk').hide();
                $('#pCocukMobileMenu').hide();
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').show();


                $('#pWomenMobileMenu').hide();
                $('#pMenMobileMenu').hide();
                $('#pHomeMobileMenu').show();
                $.cookie('genderCookie', "home");
                setTimeout(function () {
                    $("#shopWomen").parents('.accordion-item').addClass("active");
                    $("#shopMen").parents('.accordion-item').addClass("active");
                }, 500);
            } else if ($(this).hasClass("cocuk")) {
                //$('#women').html('');
                //GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#cocuk').show();

                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListCocuk').show();


                $('#pWomenMobileMenu').hide();
                $('#pMenMobileMenu').hide();
                $('#pHomeMobileMenu').hide();
                $('#pCocukMobileMenu').show();
                $.cookie('genderCookie', "cocuk");
                setTimeout(function () {
                    $("#shopWomen").parents('.accordion-item').addClass("active");
                    $("#shopMen").parents('.accordion-item').addClass("active");
                }, 500);
            }
        });

        $('body').on('click', '.tab-home ul li a', function () {
            $('.tab-home ul li a').removeClass("active");
            $(this).addClass("active");

            if ($(this).attr("data-href") == "women") {
                //  $('#men').html('');
                //  GetPTView("PWomen", "#women");
                $('#men').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#women').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#women').fadeIn();
                //$('.women-slider').html('');
                //layoutModule.GetSliderByID(1142, ".women-slider");

                $('#menuListMen').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListHome').hide();
                $('#menuListPet').hide();
                $('#menuListWomen').show();
                $.cookie('genderCookie', "women");


            } else if ($(this).attr("data-href") == "men") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#men').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#men').fadeIn();
                //$('.men-slider').html('');
                //layoutModule.GetSliderByID(1141, ".men-slider");
                $('#menuListWomen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListMen').show();
                $.cookie('genderCookie', "men");
            } else if ($(this).attr("data-href") == "home") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#home').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#home').fadeIn();
                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListHome').show();
                $.cookie('genderCookie', "home");
            } else if ($(this).attr("data-href") == "turkishDesigners") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#pet').hide();
                $('#turkishDesigner').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#turkishDesigner').fadeIn();
                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListPet').hide();
                $('#menuListTurkishDesigner').show();
                $.cookie('genderCookie', "turkishDesigners");
            } else if ($(this).attr("data-href") == "pet") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#pet').fadeIn();
                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').show();
                $.cookie('genderCookie', "pet");
                setTimeout(function () {
                    $('[data-js=wplaceholder]').addClass('js-loaded');
                }, 3000)
            } else if ($(this).attr("data-href") == "cocuk") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#cocuk').show();
                $('#cocuk').fadeIn();

                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListCocuk').show();
                $.cookie('genderCookie', "cocuk");
                setTimeout(function () {
                    $('[data-js=wplaceholder]').addClass('js-loaded');
                }, 3000)
            }
        });


        $('body').on('click', '.gender-menu ul li a', function () {
            $('.gender-menu ul li a').removeClass("active");
            $(this).addClass("active");

            if ($(this).attr("data-href") == "women") {
                //  $('#men').html('');
                //  GetPTView("PWomen", "#women");
                $('#men').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#women').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#women').fadeIn();
                //$('.women-slider').html('');
                //layoutModule.GetSliderByID(1142, ".women-slider"); 

                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListWomen').show();
                $.cookie('genderCookie', "women");


            } else if ($(this).attr("data-href") == "men") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#men').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#men').fadeIn();
                //$('.men-slider').html('');
                //layoutModule.GetSliderByID(1141, ".men-slider"); 
                $('#menuListWomen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListMen').show();
                $.cookie('genderCookie', "men");
            } else if ($(this).attr("data-href") == "home") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#turkishDesigner').hide();
                $('#home').show();
                $('#pet').hide();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#home').fadeIn();
                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListHome').show();
                $.cookie('genderCookie', "home");
            } else if ($(this).attr("data-href") == "turkishDesigners") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#pet').hide();
                $('#turkishDesigner').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#turkishDesigner').fadeIn();
                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListPet').hide();
                $('#menuListTurkishDesigner').show();
                $.cookie('genderCookie', "turkishDesigners");
            }
            else if ($(this).attr("data-href") == "pet") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').show();
                $('#cocuk').hide();
                $('#menuListCocuk').hide();

                $('#pet').fadeIn();
                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').show();
                $.cookie('genderCookie', "pet");
                setTimeout(function () {
                    $('[data-js=wplaceholder]').addClass('js-loaded');
                }, 3000)
            } else if ($(this).attr("data-href") == "cocuk") {
                //  $('#women').html('');
                //  GetPTView("PMen", "#men");
                $('#women').hide();
                $('#men').hide();
                $('#home').hide();
                $('#turkishDesigner').hide();
                $('#pet').hide();
                $('#cocuk').show();
                $('#cocuk').fadeIn();

                //$('.home-slider').html('');
                //layoutModule.GetSliderByID(1145, ".home-slider"); 
                $('#menuListWomen').hide();
                $('#menuListMen').hide();
                $('#menuListHome').hide();
                $('#menuListTurkishDesigner').hide();
                $('#menuListPet').hide();
                $('#menuListCocuk').show();
                $.cookie('genderCookie', "cocuk");
                setTimeout(function () {
                    $('[data-js=wplaceholder]').addClass('js-loaded');
                }, 3000)
            }
        });

        /* - - Genel popup gösterim biçimi - - */
        $('body').on("click", ".fillinside", function (e) {
            e.preventDefault();
            var data = $(this).attr('href'); // tıklanan linkin href'inden html içindeki içerik id'sini alır.
            if ($(data).html().trim() != "") { // içerik olup olmadığını kontrol eder.
                layoutModule.fillinside($(data).html()); // varsa popup açar.
                $("#popupwrapin").css({ "overflow-y": "scroll", "width": "75%", "height": "75%", "background": "#fff" });
                layoutModule.setpopupsize();
            }
        });
        /* - - Genel popup gösterim biçimi - End - */
        $(".category").mouseenter(function () {
            $(".menu-darkness").show();
        });
        $(".category").mouseleave(function () {
            $(".menu-darkness").hide();
        });


        $('.openmenu').parent().mouseleave(function () {
            $('.subnavout').css('display', 'none');
            $('.openmenu').removeClass('opened');
        });
        $('.openmenu').hover(function () {
            $('.subnavout').css('display', 'none');
            $('.openmenu').removeClass('opened');
            $('.tab').removeClass('opened')
            $('.subnavout').css('display', 'none');
            var getmenuid = $(this).attr('id');
            if (getmenuid != "") {
                $('.' + getmenuid).css('display', 'block');
            }
            $(this).addClass('opened');
        });


        if ($(window).width() > 768) {
            $('#smallBasket').hoverIntent({
                over: layoutModule.getscroll,
                timeout: 300,
                out: layoutModule.callempyt
            });
        }
        if ($(window).width() < 480) {
            $('.mainslider').insertBefore($('.ww-home'));
        }

        if ($.cookie("closeNotification") == "true") {
            $('.return-notification').hide();
        }
        if ($(window).width() < 767) {
            if ($.cookie("close_label") == "closed") {
                $('.header-in').css("height", "90px");
            }
        }


        $('body').on('click', '.return-notification', function () {
            $.cookie('closeNotification', true);
            if ($.cookie("closeNotification") == "true") {
                $(this).fadeOut();
            }
        });

        $('body').on('click', '.smcx-modal-header', function () {
            var smcx = $(".smcx-modal");
            if (!smcx.hasClass('notactive')) {
                smcx.animate({
                    bottom: "-265px",
                }, 1000);
                smcx.addClass('notactive');
            } else {
                smcx.animate({
                    bottom: "0",
                }, 1000);
                smcx.removeClass('notactive');
            }
        });

        $('body').on('click', '.close-label', function () {
            $('.header-label').fadeOut();
            $('.subnavout').css('top', '144px');
            if ($(window).width() < 767) {
                $('.header-in').css("height", "90px");
            }
            layoutModule.setCookie('close_label', 'closed', 30);
        });

        $('#filterMark').attr('lang', 'en');
        if (document.location.pathname.indexOf("/markalar/") == 0) {
            $(".mli").attr("lang", "en");
            $(".mli li b").text(function () {
                return $(this).text().replace("i", "ı");
            });
        }
        if (document.location.pathname.indexOf("/yeniler/markalar/") == 0) {
            $(".mli").attr("lang", "en");
            $(".mli li b").text(function () {
                return $(this).text().replace("i", "ı");
            });
        }
        if (document.location.pathname.indexOf("ayakkabi") != -1) {
            $(".numara-filter").text("Numara");
            $(".numara-filter").next().find('.filtersearch input').attr('placeholder', 'Numara');
        }
        //    if (document.location.pathname.indexOf("cocuk") != -1) {
        //        $(".fgender").hide();
        //    }
        //    if (document.location.pathname.indexOf("/erkek/ayakkabi/") == 0) {
        //        $(".numara-filter").text("Numara");
        //    }
        $('.giz-onayla-fancy').fancybox();
        $('#giz-onayla').click(function (e) {
            e.preventDefault();
            $.fancybox.close();
        });
        $('.fancybox').fancybox();
        //plistResize();
        if ($('.sb-list li').length > 5) {
            $('#basketscroll').jScrollPane({
                showArrows: true,
                autoReinitialise: true
            });
        }

        window.inbasket = basketProductIds.split(',');
        for (var i = 0; i < inbasket.length; i++) {
            $('.pitem .tobasket input').each(function () {
                if ($(this).val() == inbasket[i]) {
                    $(this).parent().addClass('addedbefore');
                }
            });
        }


        $('body').on('click', '#popupwrapout:not(.cardRegister)', function () {
            layoutModule.closecustompopup();
        });
        var IsActive = isActive;
        var timerCookie = layoutModule.getCookie('timer_ok');
        if (timerCookie != 'ok' && IsActive != 0 && $(window).width() > 768) {
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
            getpopup = $('#popupwrapinside div:first').html();
            layoutModule.fillinside(getpopup);
            layoutModule.setCookie('timer_ok', 'ok', 30);
        } else {
        }
        $("body").on("click", ".stakip", function (e) {
            //fillinside($('#tracker-information'));
        });

        $('.stakip').fancybox({
            'modal': true
        });

        $('.stakip-mobile').fancybox({
            'modal': true
        });

        $("body").on("click", ".stakip-mobile", function (e) {
            $('#left-menu').trigger('touchstart');
            $('#closeMenu').trigger('click');
            //fillinside($('#tracker-information')); 
        });

        $('body').on('click', '.show-basket', function () {
            layoutModule.basketOpened();
        });

        $('body').on('click', '.close-small-basket, .basket-overlay', function () {
            $('.small-basket').find('.small-basket-inside').animate({
                'right': '-600px',
                'opacity': '0'
            });

            $('.small-basket').find('.small-basket-inside').removeClass('fixed');
            $('body').removeClass('fixed');
            $('.basket-overlay').hide();
            setTimeout(function () {
                $('.small-basket').find('.small-basket-inside').removeAttr("style");
            }, 500);
        });
        if ($(window).width() < 768 && $('.mobile-fixed').length > 0) {
            $(window).scroll(function () {
                if ($(document).scrollTop() >= 20) {
                    $('.mobile-fixed').removeClass('hide').addClass('show');
                }
            });
        }

        $('body').on('click', '.maincat a', function (e) {

            if ($(this).hasClass('openmenu')) {

                dataLayer.push({ 'eventAction': $(this).attr('title'), 'eventLabel': $(this).attr('title'), 'event': 'headermenu' });

                //console.log($(this).attr('title'));

            } else if ($(this).parent().hasClass('navheader')) {

                secondnav = $(this).attr('title');
                firstnav = $(this).parents('.subnavout').prev().attr('title');
                nav = firstnav + " / " + secondnav;
                //console.log(nav);
                dataLayer.push({ 'eventAction': firstnav, 'eventLabel': nav, 'event': 'headermenu' });

            } else if ($(this).parents('.navcontent').length > 0) {

                thirdnav = $(this).attr('title');
                secondnav = $(this).parent().parent().find('.navheader a').attr('title');
                firstnav = $(this).parents('.subnavout').prev().attr('title');
                nav = firstnav + " / " + secondnav + " / " + thirdnav;
                //console.log(nav);
                dataLayer.push({ 'eventAction': firstnav, 'eventLabel': nav, 'event': 'headermenu' });

            } else {
                //console.log('kırılım yok');
            }
        });

        var config = {
            over: function () { layoutModule.openmenuHover(this) },
            interval: 200,
            out: function () { layoutModule.openmenuLeave(this) }
        };

        $('.maincat').hoverIntent(config);

        //$('#main-nav .main-nav-in ul').mouseleave(function () {
        //    $('.subnavout').css('display', 'none');
        //    $('.openmenu').removeClass('opened');
        //    $('.overlay').css({ 'display': 'none' });
        //    //$('#header').removeAttr('style');
        //});

        $('#nav_11, #nav_12').mouseover(function () {
            $('.subnavout').css('display', 'none');
            $('.openmenu').removeClass('opened');
            $('.overlay').css('display', 'none', '!important');
            //$('#header').removeAttr('style');
        });

        $('body').on('click', '.usrloginclick', function () {
            $(this).next().slideDown();
        });

        $('body').on('click', '.openmenuclick', function () {
            $('.subnavout').css('display', 'none');
            $('.openmenuclick').removeClass('opened');
            $('.tab').removeClass('opened')
            $('.subnavout').css('display', 'none');
            var getmenuid = $(this).attr('data-id');
            $('.' + getmenuid).css('display', 'block');
            $(this).addClass('opened');
        });
        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
                $('.pageup').css("display", "flex");
            } else {
                $('.pageup').css("display", "none");
            }
        });
        // Pager Up
        $('body').on('click', '.pageup', function (e) {
            $('html, body').animate({
                scrollTop: 0
            }, {
                duration: 1200,
                easing: 'easeInOutExpo'
            });
        });
        //Small Basket Delete Product 
        $('body').on('click', '.remove-small-basket', function (e) {
            var pId = $(this).attr('ref');
            $.ajax({
                url: MainPath + 'Sepet/RemoveBasket',
                data: {
                    Barcode: pId
                },
                type: 'post',
                dataType: 'json',
                success: function (data) {
                    layoutModule.basketOpened();
                },
                complete: function () {
                    layoutModule.GetSmallBasket(true);
                    setTimeout(function () {
                        layoutModule.basketOpened();
                    }, 500);
                }
            })
            return false;
        });

        $('body').on('click', '.e-bulten-onay', function (e) {
            $('#chbNewslatter').prop('disabled', false);
            $('#chbNewslatter').prop('checked', true);

            return false;
        });




        //$('#chbNewslatter').prop('disabled', true);
        /* $('body').on('click', '.facebook-onay', function (e) {
        $('#fbCheckOnay3').prop('disabled', false);
        $('#fbCheckOnay3').prop('checked', true);
        return false;
        });
    
    
        $('body').on('click', '.facebook-onay-kayit', function (e) {
        $('#fbCheckOnay4').prop('disabled', false);
        $('#fbCheckOnay4').prop('checked', true);
        return false;
        });*/

        $('body').on('click', '.uye-onay', function (e) {
            $('#Sozlesme').prop('disabled', false);
            $('#Sozlesme').prop('checked', true);
            return false;
        });
        $('body').on('click', '.sms-onay', function (e) {
            $('#Register_WantsEmail').prop('disabled', false);
            $('#Register_WantsEmail').prop('checked', true);
            return false;
        });

        // E-bülten Form
        $('body').on('submit', '#addNewsletterForm', function (e) {

            //if (!$('#chbNewslatter').is(':checked')) {
            //    $('#newsletter-result').html('Bülten aboneliği talebinize onay vermelisiniz.').show().delay(5000).fadeOut(1000);
            //    return false;
            //}

            var email = $('#newslaterEmail2').val();
            //if (email == '') {
            //    email = $('#newslaterEmail').val();
            //}
            if (layoutModule.confirmNewsletter(email)) {
                e.preventDefault();
                $.ajax({
                    url: RootUrl + 'Lookup/AddNewslater',
                    data: { newslaterEmail: email },
                    type: 'POST',
                    beforeSend: function () {
                        $('#newsletter-result').html("Lütfen bekleyiniz...").show();
                    },
                    complete: function (result) {
                        //$('#newsletter-result').html(result.message).show().delay(3000).fadeOut(1000);
                    },
                    success: function (result) {
                        $('#newsletter-result').html(result.message).show().delay(10000).fadeOut(1000);
                    },
                    error: function (result) {
                        $('#newsletter-result').html(result.message).show().delay(10000).fadeOut(1000);
                    }
                });
            }
            return false;
        });
        $('body').on('submit', '#addNewsletterForm2', function (e) {
            var email = $('#newslaterEmail2').val();
            if (email == '') {
                email = $('#newslaterEmail2').val();
            }
            if (confirmNewsletter2(email)) {
                e.preventDefault();
                $.ajax({
                    url: MainPath + 'Lookup/AddNewslater',
                    data: {
                        newslaterEmail: email
                    },
                    type: 'POST',
                    beforeSend: function () {
                        $('#newsletter-result2').html('Lütfen bekleyiniz...').show();
                    },
                    complete: function (result) {
                        //$('#newsletter-result2').html(result.message).show().delay(2000).fadeOut(1000);
                    },
                    success: function (result) {
                        $('#newsletter-result2').html(result.message).show().delay(10000).fadeOut(1000);
                    },
                    error: function (result) {
                        $('#newsletter-result2').html(result.message).show().delay(10000).fadeOut(1000);
                    }
                });
            }
            return false;
        });
        $('body').on('submit', '#addNewsletterFormEng', function (e) {
            var email = $('#newslaterEmailPopup').val();
            if (confirmNewsletter3(email)) {
                e.preventDefault();
                $.ajax({
                    url: MainPath + 'Lookup/AddNewslaterEng',
                    data: {
                        newslaterEmail: email
                    },
                    type: 'POST',
                    complete: function (result) {
                        $('#newsletter-result-eng').html(result.message).show().delay(10000).fadeOut(1000);
                    },
                    success: function (result) {
                        $('#newsletter-result-eng').html(result.message).show().delay(10000).fadeOut(1000);
                    },
                    error: function (result) {
                        $('#newsletter-result-eng').html(result.message).show().delay(10000).fadeOut(1000);
                    }
                });
            }
            return false;
        });

        $('body').on('click', '.closeanketbtn', function (e) {

            $('.anket-btn').fadeOut();

        });
        setTimeout(function () {
            $('.anket-btn').fadeOut();
        }, 15000);
        if (device) {
            if (window.location.pathname == '/Icerik/GetContent/2766') {
                $('#userleftmenu').hide();
            }
            if (window.location.pathname == '/uye') {
                $('#container').css('margin-top', '70px');
            }
            if (window.location.pathname == '/Sepet') {
                $('#container').css('margin-top', '0');
            }
            if (window.location.pathname == '/Siparis/Teslimat') {
                $('#container').css('margin-top', '0');
            }
            if (window.location.pathname == '/Siparis/Odeme') {
                $('#container').css('margin-top', '0');
            }
        }
        if (window.location.pathname == '/yeniyil') {
            $('.right-poncik').hide();
            $('.left-poncik').hide();
            $('#main-nav .main-nav-in ul').css('margin-bottom', '0');
            $('.maincat img').css('top', '95px');
            $('.maincat').css('line-height', '18px');
        }


        $('body').on('click', '.searchbtn', function () {
            $('#search').fadeIn();
        });

        $('body').on('click', '.searchbtn-close a', function () {
            $('#search').fadeOut();
        });

        $('.campaignPopupin').append('<a href="javascript:void(0);" class="closepopup kampanyakapat" onclick="layoutModule.closecustompopup();" title="Kapat"></a>')

        if ($(window).width() > 767) {
            layoutModule.sticky();
        }

        if ($('#usermenu ul#usrLogin li.usrHeaderLogined a.wfirst').text().slice('0', '5') == "guest") {
            $('.usrHeaderLogined').html('');
            $('.usrHeaderLogined').html('<a href="javascript:void(0);" class="wfirst" title="Merhaba, Misafir">Merhaba, Misafir<span></span></a>');
        }

        if ($('.checkoutLeft .user').text().slice('0', '5') == "guest") {
            $('.checkoutLeft .user').text("Merhaba, Misafir");
            $('.checkoutLeft .user').attr('title', 'Merhaba, Misafir');
        }


        if ($.cookie("campaignPopup") != "true" && $('#campaignPopup').length != 0 && $(window).width() > 768 && document.location.pathname != "/Sepet") {
            layoutModule.fillinside($('.campaignPopupin'));
            $('.campaignPopupin').parent().css('padding', '0');
        }
        $.cookie('campaignPopup', true);

        if ($.cookie("smallpopup") != "true" && $("#signInSmallPopup").length > 0 && $(window).width() > 768) {
            $("#signInSmallPopup").animate({
                opacity: 1,
                height: '65px',
                display: 'block'
            }, 1000).delay(8000).fadeOut();
            $.cookie('smallpopup', true);
        }

        layoutModule.toCallMobilePhone();


        $('body').on('click', '#frmSearchMobile .search-button', function () {
            var $inputSearch = $('[data-input-search]:visible');
            if ($inputSearch.val() == "Ürün, kategori veya marka ara" || $inputSearch.val() == "") {
                $inputSearch.attr('placeholder', 'Aramak istediğiniz kelimeyi yazınız').focus();
                return false;
            } else {
                return true;
            }
        });
        $('body').on('click', '#frmSearch .search-button', function () {
            var $inputSearch = $('[data-input-search]:visible');
            if ($inputSearch.val() == "Ürün, kategori veya marka ara" || $inputSearch.val() == "") {
                return false;
            } else {
                return true;
            }
        });

        $('#navfrmSearch').on('submit', function () {
            if ($('.searchinput').val() == "" || $('.searchinput').val() == "Ne aramıştınız?") {
                $("#mobile-search-warning").html('<p style="color:red;">Aranacak Kelimeyi Giriniz.</p>').redAlert();
                return false;
            }

        });
        $('body').on('keyup', '.searchinput', function () {
            if ($('.searchinput').val() == "" || $('.searchinput').val() == "Ne aramıştınız?") {
                $("#mobile-search-warning").show();
            } else {
                $("#mobile-search-warning").hide();
            }

        });
        //$.mask.definitions['~'] = '[1-9 ]';
        $(".main-gsmmask #Register_Tel").mask("0(~99) 999 99 99");

        $('#smallBasket').mouseenter(function () {
            $('.basketinfo').addClass('swing').addClass('animated');
            $('#showbasket').addClass('swing').addClass('animated');
        });
        $('#smallBasket').mouseleave(function () {
            $('.basketinfo').removeClass('swing').removeClass('animated');
            $('#showbasket').removeClass('swing').removeClass('animated');
        });

        $('#logo').addClass('flipInX').addClass('animated');

        $('.maincat').hover(function () {
            var picture = $(this).find('.changeContent img');
            var title = $(this).find('.changeContent h5');
            var content = $(this).find('.changeContent h4');
            var first = $(this).find('.one li:first-child');
            picture.attr('src', first.attr('data-picture'));
            title.html(first.attr('data-title'));
            content.html(first.attr('data-content'));
        });
        $('.leftcolumn .navv li').hover(function () {
            var title = $(this).attr('data-title');
            var content = $(this).attr('data-content');
            var picture = $(this).attr('data-picture');
            var change = $(this).parent().parent().parent().parent().parent().find('.changeContent');
            change.find('img').attr('src', picture);
            change.find('h5').html(title);
            change.find('h4').html(content);
        });

        $('body').on('submit', '#frmSearch', function () {
            var $inputSearch = $(this).find('[data-input-search]');
            if ($inputSearch.val() == "Ürün, kategori veya marka ara") {
                return false;
            }
        });

        $('body').on('keyup', '[data-input-search]', function () {
            if ($(this).val() != "Ürün, kategori veya marka ara") {
                if ($('.searchinput').val().trim().length > 0) {
                    $('#frmSearch').attr('onkeypress', ' ');
                    $('.search-button').css('display', 'block');

                } else {
                    $('#frmSearch').attr('onkeypress', 'return event.keyCode != 13;');
                    //$('.search-button').css('display', 'none');
                }
            }
            if ($(this).val() == 0) {
                $("[data-search-result]").hide();
            }
        });
        $('body').on('mouseleave', '[data-input-search]', function () {
            if ($(this).val() != "Ürün, kategori veya marka ara") {
                if ($('.searchinput').val().trim().length > 0) {
                    $('#frmSearch').attr('onkeypress', ' ');
                    $('.search-button').css('display', 'block');
                } else {
                    $('#frmSearch').attr('onkeypress', 'return event.keyCode != 13;');
                    //$('.search-button').css('display', 'none');
                }
            }
            if ($(this).val() == 0) {
                $("[data-search-result]").hide();
            }
        });
        $("#frmSearchMobile .searchinput").keypress(function (event) {
            if (event.which == 13) {
                event.preventDefault();
                $("#frmSearchMobile").submit();
            }
        });
        $(".m-search-input").keypress(function (event) {
            if (event.which == 13) {
                $(".m-search-button").trigger('click');
            }
        });

        $('body').on('keyup', '[data-input-search]', function () {
            if ($(this).val().length == 0) {
                $('#searchwrap').slideUp('fast');
            }
        });



        $('body').on('click', '.search-btn-mobile', function () {
            $('#searchHomeMobile').show();
        });
        $('body').on('click', '#searchHomeMobile #frmSearchMobile .close-btn', function () {
            $('#searchHomeMobile').hide();
        });


        $("[data-input-search]").autocomplete({
            delay: 2,
            source: function (request, response) {
                $.ajax({
                    url: MainPath + "Lookup/Suggestion/",
                    dataType: "json",
                    data: { id: request.term },
                    minLength: 4,
                    success: function (data) {
                        if (typeof (data) != "undefined") {
                            console.log(data);
                            if (data.department != null && data.department.length > 0) {
                                $('.s-result-1').html('');
                            }
                            $('[data-search-result]').fadeIn();
                            window.d = 0;
                            if (data != null) {
                                if (data.department != null && data.department.length > 0) {
                                    for (d = 0; d <= data.department.length - 1; d++) {
                                        var setdepname = data.department[d].split("|")[2].replace(/\-/g, ' ');
                                        var setdepurl = data.department[d].split("|")[2];
                                        if ($('.s-result-1 a').html() != data.department[d]) {
                                            $('.s-result-1').append('<li><a href="/' + setdepurl + '"><span>' + setdepname + '</span></a></li>');
                                        }
                                    }
                                }
                            }

                        }

                    }
                });
            }
        });

        $('body').on('click', '.search-close a', function () {
            $('.search-form').slideUp();
            $('[data-search-result]').removeAttr('style');
            $('[data-search-result] .s-result-1').html('');
        });

        $('body').on('click', '.search-open a', function () {
            $('.search-form').slideDown();
            $('.searchinput').focus();
        });

        $('body').on('click', ".townList li", function (e) {
            $('#searchTown').val($(this).text());
            $('#TownId').val($(this).val());
            $(this).parent().fadeIn();
        });




        $('body').on('click', ".taxlink", function (e) {
            $(this).hide();
            $('.tax-note').show();
            if ($(window).width() <= 767) {
                if ($(this).hasClass('opened')) {
                    $('.cancel-tax').hide();
                    $('.hiddentax').fadeOut();
                    $(this).removeClass('opened');
                    $(this).show();
                } else {
                    $('.cancel-tax').show();
                    $('.hiddentax').fadeIn();
                    $(this).addClass('opened');
                }
            } else {
                if ($(this).hasClass('opened')) {
                    $('.cancel-tax').hide();
                    $('.hiddentax').fadeOut();
                    $(this).removeClass('opened');
                    $(this).show();
                } else {
                    $('.cancel-tax').show();
                    $('.hiddentax').fadeIn();
                    $(this).addClass('opened');
                }
            }
        });

        $('body').on('click', ".cancel-tax", function (e) {

            $('.taxlink').trigger('click');
        });

        //    $('body').on('click', '.accordion-wrap', function () {
        //        $(this).parent().toggleClass('active');
        //        $(this).parent().siblings('.accordion-item').removeClass('active');
        //        $(this).next('div').stop().slideToggle();
        //        $(this).parent().siblings().children().next().slideUp();
        //        return false;
        //    });
        $('body').on('click', '.accordion-header', function (e) {
            if ($(this).next().hasClass('accordion-content')) {
                e.preventDefault();

                $(this).parent().toggleClass('active');
                $(this).parent().siblings('.accordion-item').removeClass('active');
                $(this).next('.accordion-content').stop().slideToggle();
                if (!$(this).hasClass('main')) {
                    $(this).parent().siblings().children().next().slideUp();



                }
            } else {
                window.location.href = $(this).find('a').attr('href');
            }

        });

        //mobile left menu
        $('body').on('click', '#MobileNav li a', function (e) {
            if (!$(this).next().hasClass('levelHolderClass')) {
                window.location.href = $(this).find('a').attr('href');
            }

        });

        /* Delivery - Payment -  Payment Result*/
        window.setwidthprog = $('.activestep').attr('data-slide');
        layoutModule.setnav(setwidthprog);
        /* Teslimat Ödeme Özet*/
        $('body').on('click', '#product_detail_back', function () {
            layoutModule.backtoblack();
        });
        $('body').on('keyup', '#search .searchinput', function () {
            if ($('#search .searchinput').val().trim().length > 0) {
                $('#frmSearch').attr('onkeypress', ' ');
            } else {
                $('#frmSearch').attr('onkeypress', 'return event.keyCode != 13;');
            }
        });
        $('body').on('mouseleave', '#search .searchinput', function () {
            if ($('#search .searchinput').val().trim().length > 0) {
                $('#frmSearch').attr('onkeypress', ' ');
            } else {
                $('#frmSearch').attr('onkeypress', 'return event.keyCode != 13;');
            }
        });
        $('body').on('keyup', '#navsearch .searchinput', function () {
            if ($('#navsearch .searchinput').val().trim().length > 0) {
                $('#navfrmSearch').attr('onkeypress', ' ');
            } else {
                $('#navfrmSearch').attr('onkeypress', 'return event.keyCode != 13;');
            }
        });
        $('body').on('mouseleave', '#navsearch .searchinput', function () {
            if ($('#navsearch .searchinput').val().trim().length > 0) {
                $('#navfrmSearch').attr('onkeypress', ' ');
            } else {
                $('#navfrmSearch').attr('onkeypress', 'return event.keyCode != 13;');
            }
        });
        $('body').on('blur', '#Tel', function () {
            var value = $(this).val();
            $(this).parent().find('.messagebox').remove();
            $(this).parent().find('.checkgreen').remove();
            if (value == '' || value == null || value == "(___) ___ __ __") {
                $(this).after('<span class="messagebox"><span class="tip"></span><span class="message">Bu alanı doldurmalısınız.</span></span>');

            } else if ((value.length == 15) && !(value.indexOf("_") != -1)) {
                //console.log(value); 
                if (!$(this).next().hasClass('checkgreen')) {
                    $(this).after('<span class="checkgreen"></span>');
                }
            }
        });
        $('#payment-nav a').click(function () {
            $('#payment-nav a').attr('class', '');
            $(this).addClass('selected');
        });
        $('.tabs').tabs();
        $('body').on('click', '.ui-combobox input', function () {

            //        if ($(this).parent().parent().hasClass('choosenTown')) {
            //            if ($('.choosenCity .ui-combobox input').val() == "") {
            //                $($(this)).after('<span class="messagebox"><span class="tip"></span><span class="message">Önce il seçmelisiniz!</span></span>');
            //            }
            //        } else {
            //            $('.choosenCity .messagebox, .choosenTown .messagebox').remove();
            //        }

            //console.log('clicked');
            $(this).select();
            //$(".choosenCity .ui-widget").show();
            $(this).parent().find('.ui-combobox-toggle').trigger('click');
            layoutModule.widgetScroll();
        });
        if (discountBandLastDate != "0" && $.cookie("closeBand") != "true" && discountBandLastDate != null && location.pathname != "/" && location.pathname.indexOf("Siparis") == -1) {
            function e() {
                var e = new Date;
                e.setDate(e.getDate() + 60);
                dd = e.getDate();
                mm = e.getMonth() + 1;
                y = e.getFullYear();
                futureFormattedDate = mm + "/" + dd + "/" + y;
                return futureFormattedDate
            }

            setTimeout(function () {
                layoutModule.openBand();
            }, 2000);
        }

        $('body').on('click', '.closeBand', function () {
            layoutModule.closeBand();
        });
        $('body').on('click', '.close-label', function () {
            if (!device) {
                $('#container').css('margin-top', '0');
                $('.maincat > img').css('top', '53px');
                $('.left-poncik').css('top', '135px');
                $('.right-poncik').css('top', '135px');
            }
            //    else {
            //        $('#container').css('margin-top', '60px');
            //    } 
        });
        if (device) {
            if (!$('.container').parent().hasClass('header-label')) {
                $('#container').css('margin-top', '60px');
            }
        }
    },
    trackingTagManager: function (container, type, page) {
        $(container).find('a').click(function (e) {
            //e.preventDefault();
            if ($(this).attr('title') && $(this).attr('data-order')) {
                dataLayer.push({ 'eventCategory': page, 'eventAction': $(this).attr('title'), 'eventLabel': $(this).attr('data-order'), 'event': type });
            }
        });
    },
    /* - - User Menu Hover - - */
    userMenuHover: function () {
        $('.logined').hoverIntent({
            over: layoutModule.userDown,
            timeout: 300,
            out: layoutModule.userUp
        });
    },
    /*  - - Mobil Durum tespiti ve taglarınn yeniden yerleşimi - - */
    mobileResize: function () {
        if ($('#wrap').height() > $(window).height()) {
            window.scrollBar = 17; // wrap window'dan uzunsa scrollBar vardır.
        }

        // Window genişliği ve scroll bar değeri 769'dan küçük ise ya da tarayıcı bir mobil cihazdan ise
        if ($(window).width() + scrollBar < 768 || /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) == true) {
            window.device = true;
            $('body').addClass('device');
        }
        else {
            window.device = false;
            $('body').removeClass('device');
        }

        $('.banner-content').height($('.banner-image img').height());

    },
    signInCheckboxheaderControl: function () {
        var status = $('#Register_Contractheader').is(':checked');
        if (status == false) {
            $('#sozlesmeTextheader').animate({
                'color': 'Red'
            }, 300).animate({
                'color': '#6a6a6a'
            }, 300).animate({
                'color': 'Red'
            }, 300).animate({
                'color': '#6a6a6a'
            }, 300)
            return false;
        }
        else {
            $('#sozlesmeTextheader').css({
                'color': '#818181'
            });
            return true;
        }
    },
    setCookie: function (c_name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var c_value = escape(value) + ((exdays == null) ? '' : '; expires=' + exdate.toUTCString());
        document.cookie = c_name + '=' + c_value;
    },
    getCookie: function (c_name) {
        var c_value = document.cookie;
        var c_start = c_value.indexOf(' ' + c_name + '=');
        if (c_start == -1) {
            c_start = c_value.indexOf(c_name + '=');
        }
        if (c_start == -1) {
            c_value = null;
        }
        else {
            c_start = c_value.indexOf('=', c_start) + 1;
            var c_end = c_value.indexOf(';', c_start);
            if (c_end == -1) {
                c_end = c_value.length;
            }
            c_value = unescape(c_value.substring(c_start, c_end));
        }
        return c_value;
    },
    basketOpened: function () {
        if (device) {
            window.location = MainPath + "Sepet";
        } else {
            $('.small-basket').find('.small-basket-inside').addClass('fixed');
            $('body').addClass('fixed');
            $('.basket-overlay').show();
        }
    },
    getFavoriteCount: function () {
        var favoriteCountElement = $('[data-js=favorite-count]');
        $.ajax({
            url: MainPath + "Uye/GetWishList",
            type: "get",
            success: function (data) {
                if (data != null && data != undefined) {
                    if (data.Products.length > 0) {
                        favoriteCountElement.parent().addClass("js-active");
                        favoriteCountElement.html(data.Products.length);
                    } else {
                        favoriteCountElement.html("0");
                    }
                }
            },
            complete: function () {

            }
        }).done(function () {
        });
    },
    GetSmallBasket: function (showDetail) {
        if (showDetail == null)
            showDetail = false;
        $.get('/Lookup/GetSmallBasket?rand=' + Math.random(), function (data) {
            $('.small-basket').html(data);

            if ($('.pageup').length > 0) {
                $('.pageup').attr('data-cart-count', $('.show-basket').find('.count').html());
            }

            if (!showDetail) {
                $('.small-basket').show();
            }

            if ($('.sb-list li').length > 3) {
                $('#basketscroll').jScrollPane({
                    showArrows: true,
                    autoReinitialise: true
                });
            }
        });
    },
    getscroll: function () {

        $("#basketscroll").jScrollPane({
            showArrows: true,
            autoReinitialise: true
        });

        if (!$('#basketin').is(':animated')) {
            $('#basketin').slideDown(500);
        }

    },
    callempyt: function () {
        if (!$('#basketin').is(':animated')) {
            $('#basketin').slideUp(500);
        }

    },
    validateEmail: function (email) {
        var re = /^[a-zA-Z0-9]{1,1}[-.\w+]{0,63}(@){1}[a-zA-Z0-9-]{1,50}(\.){1}[a-zA-Z0-9]{2,4}((\.){1}[a-zA-Z0-9]{2,3}){0,1}$/;
        return re.test(email) && !email.includes('@xn--');
    },
    confirmNewsletter: function (mail) {
        var valid = layoutModule.validateEmail(mail);
        if (!valid) {
            $('#newsletter-result').html('Geçerli mail adresi giriniz.').show().delay(2000).fadeOut(1000);
            return false;
        } else {
            $('#newsletter-result').html('');
            return true;
        }
    },
    confirmNewsletter2: function (mail) {
        var valid = validateEmail(mail);
        if (!valid) {
            $('#newsletter-result2').html('Geçerli mail adresi giriniz.').show().delay(2000).fadeOut(1000);
            return false;
        } else {
            $('#newsletter-result2').html('');
            return true;
        }
    },
    confirmNewsletter3: function (mail) {
        var valid = validateEmail(mail);
        if (!valid) {
            $('#newsletter-result-eng').html('Geçerli mail adresi giriniz.').show().delay(2000).fadeOut(1000);
            return false;
        } else {
            $('#newsletter-result-eng').html('');
            return true;
        }
    },
    errorInputControl: function (inputName, spanName, chose) {
        if (chose == 1) {
            if ($(inputName).val() == '') {
                $(spanName).attr('class', 'inputActive');
                $(inputName).validateControl();
                return false;
            } else if (jQuery.trim($(inputName).val()).length == 0) {
                $(spanName).attr('class', 'inputActive');
                $(inputName).redAlert();
                return false;
            } else {
                $(spanName).attr('class', 'inputPassive');
                return true;
            }
        } else if (chose == 2) {
            if ($(inputName).text() == 'Seçim Yapınız') {
                $(spanName).attr('class', 'inputActive');
                return false;
            } else {
                $(spanName).attr('class', 'inputPassive');
                return true;
            }
        }
    },
    /* Popup starts here */
    fillinside: function (getinside) {
        $('#popupwrap').fadeIn(50);
        $('#popupwrapinside').html(getinside);
        if ($('#popupwrapin .closepopup').size() == 0) {
            $('#popupwrapin').prepend('<a href="javascript:void(0);" class="closepopup" onclick="layoutModule.closecustompopup();" title="Kapat"></a>');
        }
        layoutModule.setpopupsize();
        if (($('#quicklookinside_left').has('#quickslider'))) {
            $('#quickslider').bxSlider({
                pager: false
            });
        }
    },
    setpopupsize: function () {
        window.getwidth = $(window).width();
        window.getpopupwidth = $('#popupwrapin').width();
        window.popupleft = '0';
        window.popupleft = ((getwidth - getpopupwidth) / 2);
        layoutModule.fromtop();
    },
    setpopupsizeactive: function () {
        window.getwidth = $(window).width();
        window.getpopupwidth = $('#popupwrapin').width();
        window.popupleft = ((getwidth - getpopupwidth) / 2);
        var getheight = $(window).height();
        var getpopupheight = $('#popupwrapin').height();
        var popuptop = ((getheight - getpopupheight) / 2);
        $('#popupwrapin').css({
            'top': popuptop,
            'left': popupleft
        });
        $('.closepopup').css('top', popuptop);
    },
    fromtop: function () {
        var getheight = $(window).height();
        var getpopupheight = $('#popupwrapin').height();
        //$('#popupwrapin').css('top', -getpopupheight);
        //var popuptop = ((getheight - getpopupheight) / 2);
        var popuptop = (getheight - getpopupheight) / 2;
        $('#popupwrapin').css({
            'left': popupleft,
            'top': popuptop
        });
        $('#popupwrapin').animate({
            top: popuptop
        }, 500);
    },
    fromdownback: function () {
        var getheight = $(window).height();
        var getpopupheight = $('#popupwrapin').height();
        $('#popupwrapin').animate({
            top: '+=-700'
        }, 500);
    },
    fromdown: function () {
        var getheight = $(window).height();
        var getpopupheight = $('#popupwrapin').height();
        $('#popupwrapin').animate({
            top: '+=700'
        }, 500);
    },
    closecustompopup: function () {
        $('#popupwrap').fadeOut();
        $('#popupwrapin').html();
        $('#popupwrapin').animate({
            top: -$('#popupwrapin').height()
        }, 500);
        if ($('.cardRegister').is('.cardRegister')) {
            $('.phoneCardRegisterAgain').show();
        }
        $('#popupwrapout').removeClass('cardRegister');
    },
    userDown: function () {
        $(this).find('.user-list').slideDown(500);
    },
    userUp: function () {
        $(this).find('.user-list').slideUp(500);
    },
    openmenuHover: function (el) {
        if (!$(el).find(".openmenu").is("#nav_0") && !$(el).find(".openmenu").is("#nav_9")) {
            $('.subnavout').css('display', 'none');
            $('.openmenu').removeClass('opened');
            $('.tab').removeClass('opened')
            $('.subnavout').css('display', 'none');
            var getmenuid = $(el).find(".openmenu").attr('id');
            $('.' + getmenuid).css('display', 'block');
            $(el).addClass('opened');
            $('.overlay').css({ 'display': 'block' });
        }
    },
    openmenuLeave: function (el) {
        $('.subnavout').css('display', 'none');
        $('.openmenu').removeClass('opened');
        $('.tab').removeClass('opened')
        $('.subnavout').css('display', 'none');

        $('.overlay').css({ 'display': 'none' });
    },
    updatequenbasket: function () {
        $.get('/Lookup/GetSmallBasket?rand=' + Math.random(), function (data) {
            $('#smallBasket').html(data);
        });
    },
    ShowMessage_ProductBottom: function (data, _this) {
        _this.parents().eq(2).find('.page-message-left').removeClass('error').removeClass('info');
        _this.parents().eq(2).find('.page-message-left').addClass(data.type).html(data.message).fadeIn('slow').delay('8000').fadeOut('slow');
        if (data.type == 'error' && data.message.indexOf('girişi') > -1) {
            _this.parents().eq(2).find('.page-message-left').append('<a href="/Uye" class="gologin fancybox">Giriş Yap</a>');
        } else {
            var datatype = data.type;
        }
    },
    ShowMessage_ProductBottomQuicklook: function (data, _this) {
        _this.parent().parent().find('#page-message-left-quicklook').removeClass('error').removeClass('info');
        _this.parent().parent().find('#page-message-left-quicklook').addClass(data.type).html(data.message).fadeIn('slow').delay('8000').fadeOut('slow');
        if (data.type == 'error' && data.message.indexOf('girişi') > -1) {
            _this.parent().parent().find('#page-message-left-quicklook').append('<a href="/Uye" class="gologin fancybox">Giriş Yap</a>');
        } else {
            var datatype = data.type;
            //    console.log('type error değil' , datatype);    
        }
    },
    GetUserMenu: function (viewName, contentBox) {
        $.get(MainPath + "Home/UserMenu?viewName=" + viewName, function (data) {
            if (data != "") {
                $(contentBox).html(data);
                setTimeout(function () {
                    if ($('.user-login').hasClass("logined")) {
                        layoutModule.userMenuHover();
                    }
                }, 500);
            }
        });
    },
    /* - - - Get Content to ID - - - */
    GetContentByID: function (cid, cdom) { // cid = Content ID , cdom = Content'in append edileceği yer.
        $.ajax({
            url: MainPath + "Home/GetContent",
            data: { id: parseInt(cid) },
            type: "get",
            cache: true,
            success: function (data) {
                if (data != null && data != undefined) {
                    $(cdom).append(data);
                }
            },
            complete: function () {

            }
        }).done(function () {
            layoutModule.flexSliderInit();
        });
        return false;
    },
    /* - - - Get Content to ID - - - */
    /* - - - Home Get Main Slider - - - */
    GetSliderByID: function (cid, cdom) { // cid = Content ID , cdom = Content'in append edileceği yer.
        //$.ajax({
        //    url: MainPath + "Home/GetMainSlider",
        //    data: { id: parseInt(cid) },
        //    type: "get",
        //    cache: true,
        //    success: function (data) {
        //        if (data != null && data != undefined) {
        //            $(cdom).append(data);
        //        }
        //    },
        //    complete: function () {

        //    }
        //}).done(function () {
        //    layoutModule.flexSliderInit();
        //});
        return false;
    },
    /* - - - Get Partial View - - - */
    GetPTView: function (cview, cdom) {
        $.ajax({
            url: MainPath + "Home/GetPartialView",
            data: { viewName: cview },
            type: "get",
            cache: true,
            success: function (data) {
                if (data != null && data != undefined) {
                    if ($(cdom).length > 0) {
                        $(cdom).append(data);
                    }
                }
            },
            complete: function () {

            }
        }).done(function () {
            layoutModule.flexSliderInit();
            if ($(cdom).find(" > div").length > 1) {
                $(cdom).find(" > div:first").remove();
            }

        });
        return false;
    },
    /* - - - Get Partial View - - - */
    flexSliderInit: function () {
        $('.flexslider').each(function () {
            if ($(this).find("ul.slides > li").length > 1) {
                $(this).flexslider({
                    animation: "slide",
                    directionNav: true,
                    controlNav: false,
                    initDelay: 500,
                    slideshowSpeed: 5000,
                    animationSpeed: 500,
                    slideshow: true
                });
            } else {
                $('.flexslider .slides>li').show();
            }
            $(this).find("img").css("opacity", "1");
        });
    },
    getReqID: function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        //if (msie > 0) // If Internet Explorer, return version number
        //{
        //} else {
        //    if (!!navigator.userAgent.match(/Trident\/7\./)) {
        //        var getParam = $.urlParam('clickid');
        //        $.cookie("reqID", getParam);
        //    } else {
        //        var urlParams = new URLSearchParams(window.location.search);
        //        if (urlParams.has('clickid')) {
        //            var getParam = urlParams.get('clickid');
        //            $.cookie("reqID", getParam);
        //            var reqID = $.cookie("reqID");
        //        }
        //    }
        //}
        function getUrlVars() {
            var vars = [], hash;
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('='); vars.push(hash[0]); vars[hash[0]] = hash[1];
            }
            return vars;
        }

        var reqID = getUrlVars()["reqID"];

        if (reqID != "" && reqID != undefined) {
            $.cookie("reqID", reqID);
        }

        $.urlParam = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        }
    },
    widgetScroll: function () {
        if ($(document).scrollTop() >= 200) {
            $(".ui-autocomplete").removeClass('topMenu');
        } else {
            $(".ui-autocomplete").addClass('topMenu');
        }
    },
    sticky: function () {

        var path = location.pathname;

        if ($(document).scrollTop() >= 50) {
            $('#header').addClass('sticky');
            $('.headerLR').hide();
            $(".sticky").animate({
                top: 0
            }, 300, function () {
            });

        }
        else {
            $('#header').removeClass('sticky');
        }

    },
    departmentSticky: function () {
        var st = 198;
        if (document.location.pathname == "/indirim") {
            st = 800;
        }
        if ($(window).width() > 768) {
            if ($(this).scrollTop() >= st) {
                $('#leftmenu').addClass('sticky');
            }
            else {
                $('#leftmenu').removeClass('sticky');
            }
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 120) {
                $('#leftmenu').removeClass('sticky');
            }
        } else {
            if ($(this).scrollTop() >= 58) {
                $('.mobile-selection').addClass('fixed');
            } else {
                $('.mobile-selection').removeClass('fixed');
            }
        }
    },
    ShowPopup: function (url) {
        $.get(url, function (data) {
            layoutModule.fillinside(data);
        });
    },
    toCallMobilePhone: function () {
        if ($(window).width() < 768) {
            $('.phonebtn').attr('href', 'tel:4448994');
        } else {
            $('.phonebtn').attr('href', '/iletisim');
        }
    },
    backtoblack: function () {
        if (document.referrer.indexOf(window.location.hostname) != -1) {
            parent.history.back();
            //return false;
        } else {
            window.open('https://www.brandroom.com.tr', '_self');
        }
    },
    setnav: function () {
        $('#setbgimg').animate({
            left: setwidthprog
        }, 2000, function () {
        });
    },
    noStockTooltip: function () {
        $('.beden-secenekleri .disable').each(function () {
            $(this).addClass('hint--right');
            $(this).attr('data-hint', 'Stokta yok');
        });
    },
    searchClose: function () {
        if ($(document).scrollTop() >= 50) {
            $('.search-form').slideUp();
            $('[data-search-result]').removeAttr('style');
            $('[data-search-result] .s-result-1').html('');
        } else {
            if (!$('.search-form').is(":visible")) {
                $('.search-form').slideDown();
                $('[data-search-result]').removeAttr('style');
                $('[data-search-result] .s-result-1').html('');
            }
        }
    },
    setSelectionRange: function (input, selectionStart, selectionEnd) {
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(selectionStart, selectionEnd);
        }
        else if (input.createTextRange) {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', selectionEnd);
            range.moveStart('character', selectionStart);
            range.select();
        }
    },
    setCaretToPos: function (input, pos) {
        layoutModule.setSelectionRange(input, pos, pos);
    },
    getSearchedTown: function (_this) {

        ul = $(_this).nextAll().slice(0, 2); // next 2
        ul.find('li').hide();

        searchList = ul.find('li').filter(
            function () {
                return $(this).text().indexOf($(_this).val()) != -1;
            }
        ).show();

        if (!$(_this).val()) {
            ul.find('li').show();
        }
        ul.fadeIn();
    },
    checkAllFormInput: function (id) {
        $("form#" + id + " :input").each(function () {
            var input = $(this);
            //console.log(input.val());
            if (input.val() != "" && input.val() != null && input.val() != "Seçim Yapınız" && input.attr('type') != 'hidden') {
                input.after('<span class="checkgreen"></span>');
            }
        });
    },
    isEmail: function (email) {
        var re = /^[a-zA-Z0-9]{1,1}[-.\w+]{0,63}(@){1}[a-zA-Z0-9-]{1,50}(\.){1}[a-zA-Z0-9]{2,4}((\.){1}[a-zA-Z0-9]{2,3}){0,1}$/;
        return re.test(email) && !email.includes('@xn--');
    },
    openBand: function () {
        window.rnd = Math.floor(Math.random() * 2);
        window.eventDate = Date.parse(discountBandLastDate) / 1e3;
        window.currentDate = Math.floor(Date.now() / 1e3);
        if (eventDate > currentDate) {
            $("#countdown").countdown({
                date: discountBandLastDate, // Change this to your desired date to countdown to
                format: "on"
            });
            $('#countdown').animate({
                height: "30px"
            }, 500);
            $('#header').addClass('mtop30');
            $('#container').addClass('mobiletop');

            if (rnd == 0) {
                $("#countdown").addClass('red');
                link = $("#countdown .cdLeft a");
                link.attr('href', link.attr('href').replace('rel=indirimbandi', 'rel=indirimbandi_red'));
            }

            $("#countdown").show();
        }
    },
    closeBand: function () {
        $('#countdown').hide();
        $('#keeptogetherfilter').removeClass('diftop');
        $('#header').removeClass('mtop30');
        $('#container').removeClass('mobiletop');
        $.cookie('closeBand', true);
    },
    buildUrl: function (url, parameters) {
        var qs = '';
        for (var key in parameters) {
            var value = parameters[key];
            if (!value) {
                continue
            }
            value = value.toString().split('"').join('"');
            qs += key + '=' + encodeURIComponent(value) + '&';
        }
        if (qs.length > 0) {
            qs = qs.substring(0, qs.length - 1);
            url = url + '?' + qs;
        }
        return url;
    }
    /* Popup ends here */

}
layoutModule.init();




window.MainWrapperSpin = function () {
    $('#container').eAjaxSpin();
    return false;
}
window.MainWrapperSpinRemove = function () {
    $('#container').eAjaxSpinRemove();
    return false;
}

jQuery.fn.ForceNumericOnly = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.charCode || e.keyCode || 0;
            // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
            return (key == 8 ||
                key == 9 ||
                key == 46 || (key >= 37 && key <= 40) || (key >= 48 && key <= 57) || (key >= 96 && key <= 105));
        });
    });
};
jQuery.fn.lengthLimit = function (length) {
    return this.each(function () {
        $(this).keydown(function (event) {
            var input = $(this).val();
            var numberOfWords = input.split(' ').length;
            if (numberOfWords == length && event.keyCode == 32) {
                return false;
            }
        }
        );
    });
};
jQuery.fn.redAlert = function () {
    if (this.alertIsRun != undefined && this.alertIsRun == true)
        return;
    this.alertIsRun = true;
    var borderColor = $(this).css('border-left-color');
    this.animate({
        'border-color': '#e32636'
    }, 'fast').animate({
        'border-color': borderColor
    }, 'fast').animate({
        'border-color': '#e32636'
    }, 'slow').animate({
        'border-color': '#CCCCCC'
    }, 'slow');
    this.alerIsRun = false;
};
jQuery.fn.validateControl = function () {
    if (this.val() == '' || this.val() == null) {
        this.redAlert();
        return false;
    }
    return true;
}
jQuery.fn.validateEmailControl = function () {
    var _value = this[0].value;
    var re = /^[a-zA-Z0-9]{1,1}[-.\w+]{0,63}(@){1}[a-zA-Z0-9-]{1,50}(\.){1}[a-zA-Z0-9]{2,4}((\.){1}[a-zA-Z0-9]{2,3}){0,1}$/;
    var _isValid = re.test(_value) && !_value.includes('@xn--');

    if (!_isValid) this.redAlert();
    return _isValid;
}
jQuery.fn.isChecked = function () {
    return (this.attr('checked') == 'checked');
}
jQuery.fn.scrollItem = function (padding) {
    if (padding == null)
        padding = 0;
    var target = $(this);
    if (target.length) {
        var top = target.offset().top - padding;
        $('html,body').animate({
            scrollTop: top
        }, 1000);
        return false;
    }
};
jQuery.widget("ui.combobox", {
    _create: function () {
        var input,
            that = this,
            wasOpen = false,
            select = this.element.hide(),
            selected = select.children(":selected"),
            defaultValue = selected.text() || "",
            wrapper = this.wrapper = $("<span>")
                .addClass("ui-combobox")
                .insertAfter(select);

        function removeIfInvalid(element) {
            var value = $(element).val(),
                matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(value) + "$", "i"),
                valid = false;
            select.children("option").each(function () {
                if ($(this).text().match(matcher)) {
                    this.selected = valid = true;
                    return false;
                }
            });

            if (!valid) {
                // remove invalid value, as it didn't match anything
                $(element).val(defaultValue);
                select.val(defaultValue);
                input.data("ui-autocomplete").term = "";
            }
        }

        input = $("<input>")
            .appendTo(wrapper)
            .val("")
            .attr("title", "")
            .attr("placeholder", $('#invoice-address').attr('data-placeholder'))
            .attr("onblur", "UpperLetterBlur(event,true)")
            .attr("onkeypress", "return UpperLetter(event);")
            .addClass("ui-state-default ui-combobox-input")
            .attr("name", "input-placeholder")
            .autocomplete({
                appendTo: wrapper.parent(),
                delay: 0,
                minLength: 0,
                autoFocus: true,
                source: function (request, response) {
                    var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
                    response(select.children("option").map(function () {
                        var text = $(this).text();
                        if (this.value && (!request.term || matcher.test(text)))
                            return {
                                label: text,
                                value: text,
                                option: this
                            };
                    }));
                },
                select: function (event, ui) {
                    ui.item.option.selected = true;
                    that._trigger("selected", event, {
                        item: ui.item.option
                    });

                    if ($(this).parent().parent().hasClass('choosenCity')) {
                        $("[ref=city][child=TownId]").trigger("change");
                    }
                    if ($(this).parent().parent().hasClass('choosenTown')) {
                        $("[ref=town][child=AreaId]").trigger("change");
                    }
                    if ($(this).parents(".choosenArea").hasClass('choosenArea')) {
                        $('#AreaId').trigger("change");
                    }
                },
                change: function (event, ui) {
                    if (!ui.item) {
                        removeIfInvalid(this);
                    }
                    if ($(this).parent().parent().hasClass('choosenCity')) {
                        invoiceValidator.element('#CityId');
                    } else if ($(this).parent().parent().hasClass('choosenTown')) {
                        invoiceValidator.element('#TownId');
                    } else {
                        invoiceValidator.element('#AreaId');
                    }
                }
            })
            .addClass("ui-widget ui-widget-content ui-corner-left");

        input.data("ui-autocomplete")._renderItem = function (ul, item) {
            return $("<li>")
                .append("<a>" + item.label + "</a>")
                .appendTo(ul);
        };

        $("<a>")
            .attr("tabIndex", -1)
            .appendTo(wrapper)
            .button({
                icons: {
                    primary: "ui-icon-triangle-1-s"
                },
                text: false
            })
            .removeClass("ui-corner-all")
            .addClass("ui-corner-right ui-combobox-toggle")
            .mousedown(function () {
                wasOpen = input.autocomplete("widget").is(":visible");
            })
            .click(function () {
                input.focus();

                // close if already visible
                if (wasOpen) {
                    return;
                }

                // pass empty string as value to search for, displaying all results
                input.autocomplete("search", "");
            });
    },

    _destroy: function () {
        this.wrapper.remove();
        this.element.show();
    }
});
jQuery.fn.countdown = function (t, n) {
    function i() {
        eventDate = Date.parse(r.date) / 1e3;
        currentDate = Math.floor(e.now() / 1e3);
        if (eventDate <= currentDate) {
            closeBand();
        }
        seconds = eventDate - currentDate;
        days = Math.floor(seconds / 86400);
        seconds -= days * 60 * 60 * 24;
        hours = Math.floor(seconds / 3600);
        seconds -= hours * 60 * 60;
        minutes = Math.floor(seconds / 60);
        seconds -= minutes * 60;
        if (days == 0) {
            thisEl.find(".timeRefDays").hide();
            thisEl.find(".days").hide();
        }
        if (r["format"] == "on") {
            days = String(days).length >= 2 ? days : "0" + days;
            hours = String(hours).length >= 2 ? hours : "0" + hours;
            minutes = String(minutes).length >= 2 ? minutes : "0" + minutes;
            seconds = String(seconds).length >= 2 ? seconds : "0" + seconds
        }
        if (!isNaN(eventDate)) {
            thisEl.find(".days").text(days);
            thisEl.find(".hours").text(hours);
            thisEl.find(".minutes").text(minutes);
            thisEl.find(".seconds").text(seconds)
        } else {
            console.log("Invalid date. Example: 30 Tuesday 2013 15:50:00");
            clearInterval(interval)
        }
    }
    var thisEl = e(this);
    var r = {
        date: null,
        format: null
    };
    t && e.extend(r, t);
    i();
    interval = setInterval(i, 1e3)
}
jQuery.validator.addMethod("specialChar", function (value, element) {
    return this.optional(element) || /^[a-zA-Z0-9[şŞıİçÇöÖüÜĞğ/.,:\-\ \s]+$/i.test(value);
}, "<span>Bu alanda özel karakter kullanılamaz.</span>");
$(window).load(function () {
    if (device) {
        if ($('.ins-top-bar-content-wrapper').length > 0) {
            var newTop = parseInt($('.ins-preview-wrapper').height()) + parseInt($('.payment-navigation-content').css('marginTop'));
            $('.payment-navigation-content').css('margin-top', newTop)
        }
    } else {
        if ($('.ins-top-bar-content-wrapper').length > 0) {
            var newTop = parseInt($('.ins-preview-wrapper').height()) + parseInt($('.payment-navigation-content').css('marginTop'));
            $('.payment-navigation-content').css('margin-top', newTop)
        }
    }
})